import axios from 'axios';
import {jwtDecode} from 'jwt-decode';
import { encryptAES, decryptAES } from "./cryptoUtils";
import { getApgJWT } from './getApgJWT'
import apiClient2 from './apiClient2';

const BASE_URL = process.env.REACT_APP_BASE_URL;


// ✅ Custom axios instance
const apiClient3 = axios.create({
 baseURL: BASE_URL,
 headers: {
   'Content-Type': 'application/json',
 },
 withCredentials: false,
});
// ✅ REQUEST INTERCEPTOR
apiClient3.interceptors.request.use(async (config) => {
const sessionToken = 'qv678BrOfw7apgYrAw5LpVJGuvtuDE0H'; // used in x-api-key
const user_id = localStorage.getItem('user_id'); 
 
    try{
      const token = await getApgJWT();
      if (token) {
        config.headers['Authorization'] = `Bearer ${token}`;
      }
    } catch (err) {
      console.error('Error fetching apg jwt token:', err);
    }

 if (config.method === 'post' && config.data) {
   const plainString = JSON.stringify(config.data);

   const encryptedPayload = encryptAES(plainString);
   config.data = { encryptedRequest: encryptedPayload };
 }
 return config;
}, (error) => Promise.reject(error));
// ✅ RESPONSE INTERCEPTOR
// RESPONSE INTERCEPTOR (simple + safe)
apiClient3.interceptors.response.use(
  (response) => {
    // 1) Pick token from body
    const token = response.data?.['jwt-token'];
    if (token) {
      localStorage.setItem("app_jwt", token);
      // 2) Decode only if it's a real JWT
      if (token.split(".").length === 3) {
        try {
          const decoded = jwtDecode(token);
          if (decoded?.exp) {
            localStorage.setItem("app_jwt_expiry", decoded.exp * 1000);
          }
        } catch (err) {
          console.warn("JWT decode skipped (invalid/opaque token):", err);
        }
      } else {
        // Apigee opaque tokens, skip decode
        console.warn("Token is not a standard JWT, skipping decode:", token);
      }
    }
    // 3) Decrypt wrapped responses (if any)
    if (response.data?.encryptedResponse) {
      try {
        console.log(response.data.encryptedResponse)
        const decrypted = decryptAES(response.data.encryptedResponse);
        console.log(decrypted)
        response.data = JSON.parse(decrypted);
      } catch (err) {
        console.error("Response decrypt error:", err);
      }
    }
    return response;
  },
  (error) => Promise.reject(error)
 );

export const generateKey = async (userId) => {
  const res = await apiClient2.post(`${BASE_URL}/biu-chatbot/generate_key`, { user_id: userId });
  return res.data.key; // "<encUser>|<encKey>"
 };
 // Send the combined key back to link USERID to KEY_VALUE
//  export const updateUserIdSSO = async (combinedKey,agentId) => {
// // generateKey('ssss','IPRU75591')
//     console.log("this is the request", { key: combinedKey.split('|')[1], user_id:agentId })
//   const res = await apiClient3.post(`${BASE_URL}/biu-chatbot/sso/modify_user_id`, { key: combinedKey.split('|')[1], user_id:agentId });
//   return res.data; 
//  };
export const updateUserIdSSO = async (combinedKey,agentId) => {
   console.log("this is the request", { key: combinedKey.split('|')[1], user_id:agentId })
 const res = await apiClient3.post(`${BASE_URL}/biu-chatbot/sso/modify_user_id`, { key: combinedKey.split('|')[1], user_id:agentId });
 try {
   const decryptedMessage = decryptAES(res.data.message);
   const parsedMessage = JSON.parse(decryptedMessage);
   if (parsedMessage.refreshToken) {
    localStorage.setItem('refresh_token', parsedMessage.refreshToken);
    localStorage.setItem('refresh_count', '0');
    startRefreshTokenTimer();
   }
 } catch (err) {
   console.error('Failed to decrypt refreshToken from modify_user_id response:', err);
 }
 return res.data;
};
 
// export default apiClient3;
// const REFRESH_ENDPOINT = 'https://api-uat.icicilife.com/v1/api/biu/liva/refreshtoken';
const REFRESH_ENDPOINT = `${BASE_URL}/biu-chatbot/refreshtoken`;
const REFRESH_INTERVAL_MS = 14 * 60 * 1000; // 14 minutes
// const REFRESH_INTERVAL_MS = 20 * 1000; // 20 sec for testing
// const REFRESH_LIMIT = 40; // limit in UAT
const REFRESH_LIMIT = 3; // limit in Prod
let refreshTimerId = null;
export const refreshAccessToken = async () => {
try {
  const refreshToken = localStorage.getItem('refresh_token');
  const userId = localStorage.getItem('user_ntid') || localStorage.getItem('ntid');
  if (!refreshToken || !userId) {
    console.warn('Skipping token refresh: missing refresh_token or user_id');
    return;
  }
  const currentCount = parseInt(localStorage.getItem('refresh_count') || '0', 10);
  if (currentCount >= REFRESH_LIMIT) {
    console.warn(`Refresh limit (${REFRESH_LIMIT}) reached. Stopping refresh timer.`);
    if (refreshTimerId) {
      clearInterval(refreshTimerId);
      refreshTimerId = null;
    }
    return;
  }
  localStorage.setItem('refresh_count', String(currentCount + 1));
   const res = await apiClient3.post(REFRESH_ENDPOINT, {
     refresh_token: refreshToken,
     user_id: userId
   });
   const newToken = res.data?.['jwt-token'] || res.data?.token;
    if (newToken) {
      localStorage.setItem('apg_jwt', newToken);
      if (newToken.split('.').length === 3) {
        try {
          const decoded = jwtDecode(newToken);
          if (decoded?.exp) {
            localStorage.setItem('apg_jwt_expiry', decoded.exp * 1000);
          } else {
            localStorage.setItem('apg_jwt_expiry', Date.now() + 500 * 1000);
          }
        } catch (err) {
          console.warn('JWT decode skipped (invalid/opaque token):', err);
          localStorage.setItem('apg_jwt_expiry', Date.now() + 500 * 1000);
        }
      } else {
        // Apigee opaque token, skip decode
        localStorage.setItem('apg_jwt_expiry', Date.now() + 500 * 1000);
      }
    }
    if (res.data?.message) {
      try {
        const decryptedMessage = decryptAES(res.data.message);
        const parsedMessage = JSON.parse(decryptedMessage);
        if (parsedMessage.refreshToken) {
          localStorage.setItem('refresh_token', parsedMessage.refreshToken);
        }
      } catch (err) {
        console.error('Failed to decrypt refreshToken from refreshtoken response:', err);
      }
    }
    console.log('Access token refreshed successfully');
  } catch (err) {
    console.error('Failed to refresh access token:', err);
  }
};
export const startRefreshTokenTimer = () => {
 if (refreshTimerId) {
   clearInterval(refreshTimerId);
 }
 refreshTimerId = setInterval(refreshAccessToken, REFRESH_INTERVAL_MS);
};
export default apiClient3;

